import ReportsIndexScreen from "@/app/(app)/(crew)/reports/index";

export default ReportsIndexScreen;
